/** Account and settings icons. */

import type { Component } from 'solid-js';
import { Svg } from './Svg.tsx';

/** Google's mark, approximated in one colour at four opacities. */
export const Google: Component = () => (
  <svg viewBox="0 0 24 24" width="19" height="19" aria-hidden="true" style={{ stroke: 'none' }}>
    <path
      fill="currentColor"
      d="M21.6 12.2c0-.7-.06-1.4-.18-2.05H12v3.9h5.4a4.6 4.6 0 0 1-2 3.02v2.5h3.23c1.89-1.74 2.97-4.3 2.97-7.37z"
    />
    <path
      fill="currentColor"
      opacity=".75"
      d="M12 22c2.7 0 4.96-.9 6.62-2.42l-3.23-2.5c-.9.6-2.05.95-3.39.95-2.6 0-4.8-1.76-5.59-4.12H3.07v2.58A10 10 0 0 0 12 22z"
    />
    <path
      fill="currentColor"
      opacity=".5"
      d="M6.41 13.9a6 6 0 0 1 0-3.82V7.5H3.07a10 10 0 0 0 0 9l3.34-2.6z"
    />
    <path
      fill="currentColor"
      opacity=".85"
      d="M12 5.96c1.47 0 2.79.5 3.83 1.5l2.86-2.86C16.95 2.99 14.7 2 12 2A10 10 0 0 0 3.07 7.5l3.34 2.58C7.2 7.72 9.4 5.96 12 5.96z"
    />
  </svg>
);

export const Key: Component = () => (
  <Svg>
    <circle cx="8" cy="12" r="3.4" />
    <path d="M11.4 12H21M17.6 12v3M20.2 12v2.2" />
  </Svg>
);

export const SignOut: Component = () => (
  <Svg>
    <path d="M14.5 16.5v2.2a1.8 1.8 0 0 1-1.8 1.8H5.8A1.8 1.8 0 0 1 4 18.7V5.3a1.8 1.8 0 0 1 1.8-1.8h6.9a1.8 1.8 0 0 1 1.8 1.8v2.2M9.6 12H20m0 0-3.2-3.2M20 12l-3.2 3.2" />
  </Svg>
);
